"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _index = _interopRequireDefault(require("./components/HeaderNav/index"));
var _index2 = _interopRequireDefault(require("./components/MortgageGuides/index"));
var _index3 = _interopRequireDefault(require("./containers/RefinancingGuide/index"));
var _index4 = _interopRequireDefault(require("./containers/BuyingAHome/index"));
var _index5 = _interopRequireDefault(require("./containers/InvestmentProperty/index"));
var _index6 = _interopRequireDefault(require("./containers/VaccationHomes/index"));
var _index7 = _interopRequireDefault(require("./containers/RentVsBuying/index"));
var _index8 = _interopRequireDefault(require("./containers/BiweeklyPayment/index"));
var _index9 = _interopRequireDefault(require("./containers/HomeBuyers/index"));
var _index10 = _interopRequireDefault(require("./containers/DownpaymentAssistance/index"));
var _index11 = _interopRequireDefault(require("./containers/MortgageProcess/index"));
var _index12 = _interopRequireDefault(require("./containers/CashoutRefinance/index"));
var _index13 = _interopRequireDefault(require("./containers/Prequalification/index"));
var _index14 = _interopRequireDefault(require("./containers/SkippedPayments/index"));
var _Documents = _interopRequireDefault(require("./containers/Documents"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function MortgageGuideRoutes(_ref) {
  let {
    homePath,
    openGuidesInNewTab,
    showHeader,
    showFooter,
    FooterComponent
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showHeader ? /*#__PURE__*/_react.default.createElement(_index.default, {
    basePath: homePath
  }) : "", /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "guides",
    element: /*#__PURE__*/_react.default.createElement(_index2.default, {
      basePath: homePath,
      openGuidesInNewTab: openGuidesInNewTab
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "refinancing-guide",
    element: /*#__PURE__*/_react.default.createElement(_index3.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "buying-a-home",
    element: /*#__PURE__*/_react.default.createElement(_index4.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "investment-property",
    element: /*#__PURE__*/_react.default.createElement(_index5.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "vacation-home",
    element: /*#__PURE__*/_react.default.createElement(_index6.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "renting-vs-buying",
    element: /*#__PURE__*/_react.default.createElement(_index7.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "biweekly-payment",
    element: /*#__PURE__*/_react.default.createElement(_index8.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "home-buyers-education",
    element: /*#__PURE__*/_react.default.createElement(_index9.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "down-payment-assistance",
    element: /*#__PURE__*/_react.default.createElement(_index10.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "mortgage-process",
    element: /*#__PURE__*/_react.default.createElement(_index11.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "cashout-refinance",
    element: /*#__PURE__*/_react.default.createElement(_index12.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "pre-qualification-and-pre-approval",
    element: /*#__PURE__*/_react.default.createElement(_index13.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "skipped-payments",
    element: /*#__PURE__*/_react.default.createElement(_index14.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: homePath + "documents",
    element: /*#__PURE__*/_react.default.createElement(_Documents.default, null)
  })), showFooter ? /*#__PURE__*/_react.default.createElement(FooterComponent, null) : "");
}
var _default = exports.default = MortgageGuideRoutes;